import * as React from "react";
import * as Sentry from "@sentry/react";
import { PageError } from "./PageError";

interface IPropsSentry {
  children?: React.ReactNode;
}

export const SentryBoundary: React.FC<IPropsSentry> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={(props) => {
        const { error } = props;
        const isObject = error != null && typeof error === "object";
        const hasMessage =
          isObject && "message" in error && typeof error.message === "string";
        const message =
          isObject && hasMessage
            ? (error.message as string)
            : String(props.error);
        return <PageError message={message} />;
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
